import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, apiError } from '../../lib/api';
import Logo from '../../components/Logo';
import { Lock } from 'lucide-react';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('mm_token', data.access_token);
      navigate('/admin');
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--mm-cream)] flex items-center justify-center px-5 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <form onSubmit={submit} className="bg-white border border-[var(--mm-line)] rounded-3xl p-7 md:p-9 space-y-5" data-testid="admin-login-form">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[var(--mm-purple)] text-white flex items-center justify-center"><Lock className="w-4 h-4" /></div>
            <div>
              <div className="mm-kicker">Content Studio</div>
              <h1 className="text-lg font-semibold text-[var(--mm-ink)]">Sign in to manage the site</h1>
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold tracking-wider text-[var(--mm-ink)]/70 uppercase mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input"
              className="w-full h-12 px-4 rounded-xl bg-[var(--mm-cream)] border border-[var(--mm-line)] text-[var(--mm-ink)]" />
          </div>
          <div>
            <label className="block text-xs font-semibold tracking-wider text-[var(--mm-ink)]/70 uppercase mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input"
              className="w-full h-12 px-4 rounded-xl bg-[var(--mm-cream)] border border-[var(--mm-line)] text-[var(--mm-ink)]" />
          </div>
          {error && <div className="text-sm text-red-600" data-testid="admin-login-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="text-center text-xs text-[var(--mm-ink)]/50 mt-6">Authorised personnel only.</p>
      </div>
    </div>
  );
}
